/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tier_3_NInputs */

const en_cp_tier_3_n = /** @type {(inputs: Cp_Tier_3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelopor`)
};

const id_cp_tier_3_n = /** @type {(inputs: Cp_Tier_3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelopor`)
};

/**
* | output |
* | --- |
* | "Pelopor" |
*
* @param {Cp_Tier_3_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tier_3_n = /** @type {((inputs?: Cp_Tier_3_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tier_3_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tier_3_n(inputs)
	return en_cp_tier_3_n(inputs)
});